/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Creem_DescriptionInputs */

const en_admin_settings_groups_creem_description = /** @type {(inputs: Admin_Settings_Groups_Creem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creem payment gateway`)
};

const zh_admin_settings_groups_creem_description = /** @type {(inputs: Admin_Settings_Groups_Creem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creem 支付网关`)
};

/**
* | output |
* | --- |
* | "Creem payment gateway" |
*
* @param {Admin_Settings_Groups_Creem_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_creem_description = /** @type {((inputs?: Admin_Settings_Groups_Creem_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Creem_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_creem_description(inputs)
	return zh_admin_settings_groups_creem_description(inputs)
});
export { admin_settings_groups_creem_description as "admin.settings.groups.creem.description" }